module.exports = __webpack_public_path__ + "img/010.da9d6a2d.png";